import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const useIsEditCartEnabled = ({ cartHasIncentive }: { cartHasIncentive?: boolean } = {}) => {
  const enableEditCart = useFlag(LaunchDarklyFlag.ENABLE_EDIT_CART);
  const enableOffersEditCart = useFlag(LaunchDarklyFlag.ENABLE_OFFERS_EDIT_CART);
  return cartHasIncentive ? enableEditCart && enableOffersEditCart : enableEditCart;
};
